import { apiClient } from '../apiClient';

export interface OrgMessage {
  id: string;
  org_id: string;
  student_id: string;
  sender_id: string;
  body: string;
  created_at: string;
}

export interface MessageThreadData {
  messages: OrgMessage[];
  self: string;
}

export interface OrgThreadPreview {
  student_id: string;
  student_name: string;
  last_body: string;
  last_at: string;
  last_sender_id: string;
  batch_name: string;
}

export const messagesApi = {
  orgThread: async (studentId: string): Promise<MessageThreadData> => {
    const { data } = await apiClient.get('/api/v1/messages', { params: { student_id: studentId } });
    return data as MessageThreadData;
  },
  studentThread: async (): Promise<MessageThreadData> => {
    const { data } = await apiClient.get('/api/v1/messages');
    return data as MessageThreadData;
  },
  send: async (body: { body: string; student_id?: string }): Promise<OrgMessage> => {
    const { data } = await apiClient.post('/api/v1/messages', body);
    return data as OrgMessage;
  },
  inbox: async (): Promise<OrgThreadPreview[]> => {
    const { data } = await apiClient.get('/api/v1/messages/inbox');
    return (data?.threads as OrgThreadPreview[]) ?? [];
  },
};
